import service from "@/utils/axios-v2";
import request from "@/utils/request";
const baseURL = "https://api.weather.gov";
const baseURL2 = "https://static-lib.truckerimg.com/fleet-weather";
const baseURL3 =
  process.env.VUE_APP_BUILD_ENV === "prod"
    ? "https://api.truckerpath.com"
    : "https://test-api.truckerpath.com";
export function getRouteWeather(data) {
  return service({
    baseURL: baseURL3,
    url: `/truckerpath-routing/tp/weather/route/queryV2`,
    method: "post",
    headers: {
      "portal-token": true,
    },
    data: data,
  });
}
export function getAlertsActive(parameter) {
  return request({
    baseURL: baseURL,
    url: `/alerts/active`,
    method: "get",
    params: parameter,
    headers: {
      "disable-token": true,
    },
  });
}
export function getAlerts(parameter) {
  return request({
    baseURL: baseURL3,
    url: `/truckerpath-routing/tp/weather/weather/query/all`,
    params: parameter,
    headers: {
      "disable-token": true,
    },
  });
}
export function getLocationGrid(parameter) {
  return request({
    baseURL: baseURL,
    url: `/points/${parameter.latitude},${parameter.longitude}`,
    method: "get",
    headers: {
      "disable-token": true,
    },
  });
}
export function getGridsForecast(parameter) {
  return request({
    baseURL: baseURL,
    url: `/gridpoints/${parameter.gridId}/${parameter.gridX},${parameter.gridY}`,
    method: "get",
    headers: {
      "disable-token": true,
    },
  });
}
export function getZonesForecast(url) {
  return request({
    baseURL: baseURL,
    url: `${url}/observations`,
    method: "get",
    headers: {
      "disable-token": true,
    },
  });
}
export function getWeatherAlertTypes() {
  return request({
    baseURL: baseURL,
    url: `/alerts/types`,
    method: "get",
    headers: {
      "disable-token": true,
    },
  });
}
export function getFleetWeatherAlertLocation(state) {
  return request({
    baseURL: baseURL2,
    url: `fleet-weather-alert-location-${state}.json`,
    method: "get",
    timeout: 180000,
    headers: {
      "disable-token": true,
    },
  });
}
